// Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

import playIcon from '../icons/01-play.svg'
import pauseIcon from '../icons/02-pause.svg'
import stopIcon from '../icons/03-stop.svg'
import volumeIcon from '../icons/04-volume.svg'
import volumeMuteIcon from '../icons/05-mute.svg'
import fullscreenIcon from '../icons/06-expand.svg'
import exitFullscreenIcon from '../icons/07-shrink.svg'
import hdIcon from '../icons/08-hd.svg'
import ccIcon from '../icons/09-cc.svg'
import reloadIcon from '../icons/10-reload.svg'

export let cc = ccIcon
export let exitFullscreen = exitFullscreenIcon
export let fullscreen = fullscreenIcon
export let hd = hdIcon
export let pause = pauseIcon
export let play = playIcon
export let reload = reloadIcon
export let stop = stopIcon
export let volume = volumeIcon
export let volumeMute = volumeMuteIcon

export default {
  cc: ccIcon,
  exitFullscreen: exitFullscreenIcon,
  fullscreen: fullscreenIcon,
  hd: hdIcon,
  pause: pauseIcon,
  play: playIcon,
  reload: reloadIcon,
  stop: stopIcon,
  volume: volumeIcon,
  volumeMute: volumeMuteIcon,
}
